import React from 'react';
import Hero from './HeroArea';
import About from './AboutArea';
import Service from './ServiceArea';
import Appointment from './AppointmentArea';
import ChooseUs from './ChooseArea';
import Contact from './ContactArea';
import Team from './TeamArea';
import Work from './WorkArea';
import Testimonial from './TestimonialArea';
import Newsletter from './NewsletterArea';
import Blog from './BlogArea';
import Donation from './donationArea';

const HomeThreeMain = () => {
  return (
    <main>
      <Hero />
      <About />
      <Service />
      <Appointment />
      <ChooseUs />
      <Contact />
      <Team />
      <Work />
      <Testimonial />
      <Newsletter />
      <Blog />
      <Donation />
    </main>
  );
};

export default HomeThreeMain;
